module.exports = __webpack_public_path__ + "static/media/icon-youtube.ef202550.svg";